exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-divider--vertical[data-v-e8d9fd4e]{height:auto}[data-v-e8d9fd4e] .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{color:#1890ff}.content[data-v-e8d9fd4e]{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:calc(100vh - 84px - 40px)}.content .left[data-v-e8d9fd4e]{width:240px}.content .right[data-v-e8d9fd4e]{-webkit-box-flex:1;-ms-flex:1;flex:1}\n", ""]);

// exports
